import moment from 'moment'

export default function (input, suffix = false)
{
	return moment(input).fromNow(suffix)
}


// WEBPACK FOOTER //
// ./src/lib/filters/timeAgo.js